import { ReactNode } from "react";
import classNames from "clsx";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useWindowDimensions } from "@/hooks/useWindowDimensions";

import { SkeletonWrapper } from "../SkeletonWrapper";

export type Props = {
	icon: ReactNode;
	label: string;
	value: string | number;
	skeleton?: boolean;
};

export function VitalSignsCard({ icon, label, value, skeleton }: Props) {
	const { width } = useWindowDimensions();

	return (
		<>
			{skeleton ? (
				<SkeletonWrapper />
			) : (
				<Row
					className={classNames(
						"border border-gray-300 border-dashed rounded min-width-13 align-items-center text-hover-primary",
						width <= 820 && "mb-1"
					)}
				>
					<Col md={2} className="my-1 w-35px">
						{icon}
					</Col>

					<Col className="d-flex flex-row gap-2 fs-7">
						<div className="fw-bolder">
							{label}: <span className="text-gray-700">{value}</span>
						</div>
					</Col>
				</Row>
			)}
		</>
	);
}
